export default __webpack_public_path__ + "static/reward-title-f229f24ee961bc9cd0072c4dc61311a3.png";